import { render, staticRenderFns } from "./AdminOrganizationsTable.vue?vue&type=template&id=5116f1dd"
import script from "./AdminOrganizationsTable.vue?vue&type=script&lang=js"
export * from "./AdminOrganizationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports